import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		token: "init",
		user: null,
		privileges: [],
		recording: {
			task_id: 0,
			started: 0,
		},
		redirect_after_logon: "/",
		breadcrumbs: [],
		pinned_abook_worklists: [],
		pinned_job_worklists: [],
		pinned_tasks_worklists: [],
	},
	getters: {
		breadcrumb_count: state => {
			return state.breadcrumbs.length;
		},
		get_last_breadcrumb: state => {
			if (state.breadcrumbs.length > 0) {
				return state.breadcrumbs[state.breadcrumbs.length - 1];
			} else {
				return null;
			}
		},
		get_breadcrumb(state) {
			return to => {
				let i;
				for (i = 0; i < state.breadcrumbs.length; i++) {
					let breadcrumb = state.breadcrumbs[i];

					if (breadcrumb.to == to) {
						return breadcrumb
					}
				}
				return null;
			}
		},
		get_pinned_abook_worklists: state => {
			return state.pinned_abook_worklists;
		},
		get_pinned_job_worklists: state => {
			return state.pinned_job_worklists;
		},
		get_pinned_tasks_worklists: state => {
			return state.pinned_tasks_worklists;
		},
		get_user: state => {
			return state.user
		},
		has_privilege: state => {
			return privilege => {
				if (privilege == "") {
					// for generic parts of the interface it can be handy to use an empty privilege.
					return true;
				};

				// check if we have access to atleast one of the specified privileges
				let privileges = privilege.split(",");
				let access = false;

				privileges.forEach(priv => {
					if (state.privileges.indexOf(priv) !== -1) {
						// console.log("Has privilege ", priv);
						access = true;
					}
				});

				// console.log("Has privilege ", privilege)
				return access;
			}
		},
	},
	mutations: {
		set_token(state, new_token) {
			state.token = new_token;

			// and attempt to store it in our local storage
			localStorage.token = state.token;
		},
		clear_token(state) {
			state.token = "";

			// clear all other info
			state.user = null;
			state.privileges = [];
			state.recording.task_id = 0;
			state.recording.started = 0;
			state.pinned_job_worklists = [];
			state.pinned_abook_worklists = [];

			// and attempt to store it in our local storage
			localStorage.token = state.token;
		},
		set_user(state, new_user) {
			// set our user state
			state.user = new_user;
		},
		set_privileges(state, privileges) {
			state.privileges = privileges;
		},
		set_redirect_after_logon(state, new_redirect) {
			if (new_redirect.startsWith('/logon')) {
				state.redirect_after_logon = "/";
			} else {
				state.redirect_after_logon = new_redirect;
			}
		},
		clear_redirect_after_logon(state) {
			state.redirect_after_logon = "/";
		},
		set_recording(state, recording) {
			state.recording.task_id = recording.task_id;
			state.recording.started = recording.started;

			// console.log("Recording set to " + state.recording.task_id + "/" + state.recording.started);
		},
		clear_breadcrumbs(state) {
			state.breadcrumbs = [];
		},
		push_breadcrumb(state, new_breadcrumb) {
			let new_breadcrumbs = [];

			// Find if this breadcrumb is already in our list, if so we update our list to that point
			let i;
			for (i = 0; i < state.breadcrumbs.length; i++) {
				let breadcrumb = state.breadcrumbs[i];

				if (breadcrumb.to == new_breadcrumb.to) {
					/* skip it

					// add our new version just in case we updated meta data
					new_breadcrumbs.push(new_breadcrumb);

					// found it, use our new list, it will be smaller or equal to what we had so...
					state.breadcrumbs = new_breadcrumbs;
					return;

					*/
				} else {
					// just add 
					new_breadcrumbs.push(breadcrumb);
				}
			}

			// Add it at the end...
			new_breadcrumbs.push(new_breadcrumb);

			// Make sure we don't keep infinite entries
			while (new_breadcrumbs.length > 4) {
				// remove the first entry
				new_breadcrumbs.shift();
			}

			// update
			state.breadcrumbs = new_breadcrumbs;
		},
		pop_breadcrumb(state) {
			// remove the last entry in breadcrumbs

			state.breadcrumbs.pop();
		},
		set_pinned_abook_worklists(state, list) {
			state.pinned_abook_worklists = [];

			list.forEach(entry => {
				state.pinned_abook_worklists.push({
					title: entry.name,
					to: '/addressbook/worklist/' + entry.id,
					enabled: true
				});
			});

			// should sort this...
			state.pinned_abook_worklists.sort(function(a, b) {
				let n = a.title.toLowerCase();
				let m = b.title.toLowerCase();

				if (n < m) { return -1; };
				if (n > m) { return 1; };

				return 0;
			});


			// console.log(state.pinned_abook_worklists)
	
		},
		set_pinned_job_worklists(state, list) {
			state.pinned_job_worklists = [];

			list.forEach(entry => {
				state.pinned_job_worklists.push({
					title: entry.name,
					to: '/jobs/worklist/' + entry.id,
					enabled: true
				});
			});

			// should sort this...
			state.pinned_job_worklists.sort(function(a, b) {
				let n = a.title.toLowerCase();
				let m = b.title.toLowerCase();

				if (n < m) { return -1; };
				if (n > m) { return 1; };

				return 0;
			});

			// console.log(state.pinned_job_worklists)
		},
		set_pinned_tasks_worklists(state, list) {
			state.pinned_tasks_worklists = [];

			list.forEach(entry => {
				state.pinned_tasks_worklists.push({
					title: entry.name,
					to: '/tasks/tasklist/' + entry.id,
					enabled: true
				});
			});

			// should sort this...
			state.pinned_tasks_worklists.sort(function(a, b) {
				let n = a.title.toLowerCase();
				let m = b.title.toLowerCase();

				if (n < m) { return -1; };
				if (n > m) { return 1; };

				return 0;
			});
		},
	},
	actions: {
		check_token(context) {
			if (context.state.token == '') {
				return;
			} else if (context.state.token == 'init') {
				return;
			}

			// try and load user info, this also doubles as validating our token.
			// if it fails we clear it
			axios.get('/api/user/me', {
				headers: {
						"Authorization": "Bearer " + context.state.token,
						"Accept": "application/json"
				}
			}).then(function(d) {
				// console.log("/api/user/me is ok and returned:");
				// console.log(d);

				let json = d.data;

				// For some reason axios isn't always converting our data
				if ((typeof json) == "string") {
					json = JSON.parse(json);
				}

				if (json.status == "OK") {
					// copy our user info
					context.commit('set_user', json.data);
					if (json.hasOwnProperty('recording')) {
						context.commit('set_recording', json.recording);
					} else {
						// may not have upgraded yet..
						context.commit('set_recording', { task_id: 0, started: 0});	
					}

					// trigger updating other info
					context.dispatch('update_privileges');
					context.dispatch('update_pinned_abook_worklists');
					context.dispatch('update_pinned_job_worklists');
					context.dispatch('update_pinned_tasks_worklists');

					// console.log("Update user");
				} else {
					console.log("Failed because: " + json.reason);

					context.commit('clear_token');

					// should probably trigger returning to logon somehow..
				}

			}).catch(function(e) {
				console.log(e);

				context.commit('clear_token');

				// should probably trigger returning to logon somehow..
			})
		},
		start_recording(context, recording) {
			// assume this will be stored correctly
			context.commit('set_recording', recording);

			// try and load user info, this also doubles as validating our token.
			// if it fails we clear it
			axios.post('/api/tasks/' + recording.task_id +'/recording', {
				started: recording.started
			}, {
				headers: {
						"Authorization": "Bearer " + context.state.token,
						"Accept": "application/json"
				}
			}).then(function(d) {
				let json = d.data;

				// For some reason axios isn't always converting our data
				if ((typeof json) == "string") {
					json = JSON.parse(json);
				}

				if (json.status != "OK") {
					console.log(json.reason);

					context.commit('set_recording', { task_id: 0, started: 0});
				}

			}).catch(function(e) {
				console.log(e);

				context.commit('set_recording', { task_id: 0, started: 0});
			})
		},
		stop_recording(context) {
			if (context.state.recording.task_id != 0) {
				let task_id = context.state.recording.task_id;

				// clear our recording
				context.commit('set_recording', { task_id: 0, started: 0});

				// and tell our database
				axios.post('/api/tasks/' + task_id +'/recording', {
					started: 0
				}, {
					headers: {
						"Authorization": "Bearer " + context.state.token,
						"Accept": "application/json"
					}
				}).then(function(d) {
					let json = d.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					if (json.status != "OK") {
						console.log(json.reason);
					}
				}).catch(function(e) {
					console.log(e);
				})
			}
		},
		update_privileges(context) {
			let url = "/api/user/me/privileges";
			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + context.state.token,
						"Accept": "application/json"
					}					
				})
				.then(d => {
					let json = d.data;

					if (json.status == "OK") {
						context.commit("set_privileges", json.data);
					}
				})
				.catch(function(e) {
					console.log(e);
					// self.errormsg = e.message;
				});
		},
		update_pinned_abook_worklists(context) {
			// need to move this into a mixin
			// let self = this; // make sure we can access this inside of our promisses

			// build our url parameters
			let params = new Array();
			params.push("class=" + encodeURIComponent("restful.addressbook.worklists"));
			params.push("include_shared=true");
			params.push("include_hidden=false");
			params.push("only_pinned=true");

			// build our url, we have to add url escaping here!
			let url = "/api/worklists";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + context.state.token,
						"Accept": "application/json"
					}
				})
				.then(function(d) {
					let json = d.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					if (json.status == "OK") {
						// console.log("got data");
						context.commit('set_pinned_abook_worklists', json.data);
					} else {
						// self.errormsg = json.reason;
					}
				})
				.catch(function(e) {
					console.log(e);
					// self.errormsg = e.message;
				});
		},
		update_pinned_job_worklists(context) {
			// need to move this into a mixin
			// let self = this; // make sure we can access this inside of our promisses

			// build our url parameters
			let params = new Array();
			params.push("class=" + encodeURIComponent("restful.jobs.worklists"));
			params.push("include_shared=true");
			params.push("include_hidden=false");
			params.push("only_pinned=true");

			// build our url, we have to add url escaping here!
			let url = "/api/worklists";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + context.state.token,
						"Accept": "application/json"
					}
				})
				.then(function(d) {
					let json = d.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					if (json.status == "OK") {
						// console.log("got data");
						context.commit('set_pinned_job_worklists', json.data);
					} else {
						// self.errormsg = json.reason;
					}
				})
				.catch(function(e) {
					console.log(e);
					// self.errormsg = e.message;
				});
		},
		update_pinned_tasks_worklists(context) {
			// need to move this into a mixin
			// let self = this; // make sure we can access this inside of our promisses

			// build our url parameters
			let params = new Array();
			params.push("class=" + encodeURIComponent("restful.tasks.lists"));
			params.push("include_shared=true");
			params.push("include_hidden=false");
			params.push("only_pinned=true");

			// build our url, we have to add url escaping here!
			let url = "/api/worklists";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + context.state.token,
						"Accept": "application/json"
					}
				})
				.then(function(d) {
					let json = d.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					if (json.status == "OK") {
						// console.log("got data");
						context.commit('set_pinned_tasks_worklists', json.data);
					} else {
						// self.errormsg = json.reason;
					}
				})
				.catch(function(e) {
					console.log(e);
					// self.errormsg = e.message;
				});
		},
	}
});
